export const ScreenTypes = {
  DriverModule: {
    Self: 'driverModule',
    BasicData: 'basicData',
    DailyActivity: 'dailyActivity',
    WeeklyActivity: 'weeklyActivity',
    MonthlyActivity: 'monthlyActivity',
    CompareActivity: 'compareActivity',
    Calendar: 'calendar',
    Attestation: 'attestation',
    Violation: 'violation',
    Timesheet: 'timesheet',
    AmountsPreview: 'amountsPreview',
    ForeignAmounts: 'foreignAmounts',
    BusinessTrip: 'businessTrip',
    UnderConstruction: 'underConstruction',
    GroupedContract: 'groupedContract',
    Contract: 'contract',
    GroupedViolation: 'groupedViolation',
    GroupedBusinessTrip: 'groupedBusinessTrip',
    GroupedTimesheet: 'groupedTimesheet',
    Schedule: 'schedule',
    NewBusinessTrip: 'newBusinessTrip',
    NewGroupedBusinessTrip: 'newGroupedBusinessTrip',
    EditBusinessTrip: 'editBusinessTrip',
    NewContract: 'newContract',
    EditContract: 'editContract',
    GpsDownload: 'gpsDownload',
    NewDriver: 'newDriver',
    EditDriver: 'editDriver',
    Groups: 'groups',
    DriverList: 'driverList',
  },
  ImportModule: {
    Self: 'importModule',
    fromFile: 'file',
    fromGps: 'gps',
    fromActivityFile: 'activity',
    currentFiles: 'currentFiles',
    previousFiles: 'previousFiles',
    fromAbsences: 'absence',
    confirmation: 'confirmation',
  },
  ExportModule: {
    Self: 'exportModule',
    imiResult: 'imiResult',
  },
  PrintoutModule: {
    Self: 'printoutModule',
  },
  TimetableModule: {
    Self: 'timetableModule',
  },
  VehicleModule: {
    Self: 'vehicleModule',
    BasicData: 'vehicleBasicData',
    Calendar: 'vehicleCalendar',
    DailyActivity: 'vehicleDailyActivity',
    WeeklyActivity: 'vehicleWeeklyActivity',
    NewVehicle: 'newVehicle',
    EditVehicle: 'editVehicle',
    Groups: 'groups',
  },
  Configuration: {
    Self: 'configuration',
    Basic: 'basic',
    BusinessTrip: 'businessTrip',
    BusinessTripRates: 'businessTripRates',
    Violation: 'violation',
    TimesheetBasic: 'timesheetBasic',
    TimesheetAdditional: 'timesheetAdditional',
    Country: 'country',
    AlertReminders: 'alertReminders',
    Printout: 'printout',
    Gps: 'gps',
    ExchangeRate: 'exchangeRate',
    MinimumWage: 'minimumWage',
    Integration: 'integration',
  },
}

export const ROUTES = {
  PostLogin: '/postLogin',
  // Techniczne trasy flow logowania/wylogowania — patrz NON_RESTORABLE_ROUTES
  // w src/config.ts (nie wolno na nie wracać po ponownym zalogowaniu).
  LoggedOut: '/logged-out',
  LogoutComplete: '/logoutComplete',
  Configuration: {
    Self: '/company/:companyId/configuration',
    Generic: '/company/:companyId/configuration/:type',
    Basic: '/company/:companyId/configuration/basic',
    BusinessTrip: '/company/:companyId/configuration/businessTrip',
    BusinessTripRates: '/company/:companyId/configuration/businessTripRates',
    Violation: '/company/:companyId/configuration/violation',
    TimesheetBasic: '/company/:companyId/configuration/timesheetBasic',
    TimesheetAdditional:
      '/company/:companyId/configuration/timesheetAdditional',
    Integration: '/company/:companyId/configuration/integration',
    Country: '/company/:companyId/configuration/country',
    AlertReminders: '/company/:companyId/configuration/alertReminders',
    Printout: '/company/:companyId/configuration/printout',
    Gps: '/company/:companyId/configuration/gps',
    ExchangeRate: '/company/:companyId/configuration/exchangeRate',
    MinimumWage: '/et/company/:companyId/configuration/minimum-wage', //'/company/:companyId/configuration/minimumWage',
  },
  CompanySelection: {
    NoCompany: '/companySelection',
    Company: '/company/:companyId/companySelection',
  },
  Dashboard: {
    NoCompany: '/dashboard',
    Company: '/company/:companyId/dashboard',
  },
  ActiveDrivers: {
    Company: '/company/:companyId/activeDrivers',
  },
  ExportModule: {
    Basic: '/company/:companyId/exportModule',
    WithDateRange: '/company/:companyId/exportModule/month/:month',
    ImiWithDateRange: '/company/:companyId/exportModule/imi/month/:month',
    ImiResult: `/company/:companyId/exportModule/${
      ScreenTypes.ExportModule.imiResult
    }/taskId/:taskId`,
  },
  ImportModule: {
    Basic: '/company/:companyId/importModule/:type',
    BasicWithId: '/company/:companyId/importModule/:type/id/:id/taskId/:taskId',
    BasicWithDriverId:
      '/company/:companyId/importModule/driver/:driverId/:type',
    WithDateRange: '/company/:companyId/importModule/:type/from/:from/to/:to',
    WithDateRangeAndDriverId:
      '/company/:companyId/importModule/driver/:driverId/:type/from/:from/to/:to',
    FromFile: `/company/:companyId/importModule/${
      ScreenTypes.ImportModule.fromFile
    }`,
    FromGps: `/company/:companyId/importModule/${
      ScreenTypes.ImportModule.fromGps
    }`,
    fromActivityFile: `/company/:companyId/importModule/${
      ScreenTypes.ImportModule.fromActivityFile
    }`,
    fromAbsences: `/company/:companyId/importModule/${
      ScreenTypes.ImportModule.fromAbsences
    }`,
    Confirmation: `/company/:companyId/importModule/${
      ScreenTypes.ImportModule.confirmation
    }/id/:id/taskId/:taskId`,
    CurrentFiles: `/company/:companyId/importModule/${
      ScreenTypes.ImportModule.currentFiles
    }`,
    PreviousFiles: `/company/:companyId/importModule/${
      ScreenTypes.ImportModule.previousFiles
    }/from/:from/to/:to`,
    FromFileWithDriver: `/company/:companyId/importModule/driver/:driverId/${
      ScreenTypes.ImportModule.fromFile
    }`,
    FromAbsencesWithDriver: `/company/:companyId/importModule/driver/:driverId/${
      ScreenTypes.ImportModule.fromAbsences
    }`,
    FromGpsWithDriver: `/company/:companyId/importModule/driver/:driverId/${
      ScreenTypes.ImportModule.fromGps
    }`,
    FromActivityFileWithDriver: `/company/:companyId/importModule/driver/:driverId/${
      ScreenTypes.ImportModule.fromActivityFile
    }`,
    CurrentFilesWithDriver: `/company/:companyId/importModule/driver/:driverId/${
      ScreenTypes.ImportModule.currentFiles
    }`,
    PreviousFilesWithDriver: `/company/:companyId/importModule/driver/:driverId/${
      ScreenTypes.ImportModule.previousFiles
    }/from/:from/to/:to`,
  },
  PrintoutModule: {
    BasicWithDateRange: '/company/:companyId/printoutModule/from/:from/to/:to',
    WithDateRange:
      '/company/:companyId/printoutModule/driver/:driverId/from/:from/to/:to',
  },
  TimetableModule: {
    BasicWithDateRange: '/company/:companyId/timetableModule/from/:from/to/:to',
    WithDateRange:
      '/company/:companyId/timetableModule/driver/:driverId/from/:from/to/:to',
  },
  VehicleModule: {
    Basic: '/company/:companyId/vehicleModule/:type?',
    BasicWithDate: '/company/:companyId/vehicleModule/:type/date/:date',
    WithDate:
      '/company/:companyId/vehicleModule/vehicle/:vehicleId/:type/date/:date',
    WithVehicle: '/company/:companyId/vehicleModule/vehicle/:vehicleId/:type?',
    BasicWithYear: '/company/:companyId/vehicleModule/:type/year/:year',
    WithYear:
      '/company/:companyId/vehicleModule/vehicle/:vehicleId/:type/year/:year',
    BasicData: `/company/:companyId/vehicleModule/vehicle/:vehicleId/${
      ScreenTypes.VehicleModule.BasicData
    }`,
    BasicDataWithNoVehicle: `/company/:companyId/vehicleModule/${
      ScreenTypes.VehicleModule.BasicData
    }`,
    NewVehicle: `/company/:companyId/vehicleModule/vehicle/:vehicleId/${
      ScreenTypes.VehicleModule.NewVehicle
    }`,
    EditVehicle: `/company/:companyId/vehicleModule/vehicle/:vehicleId/${
      ScreenTypes.VehicleModule.EditVehicle
    }`,
    Calendar: `/company/:companyId/vehicleModule/vehicle/:vehicleId/${
      ScreenTypes.VehicleModule.Calendar
    }/year/:year`,
    CalendarWithNoVehicle: `/company/:companyId/vehicleModule/${
      ScreenTypes.VehicleModule.Calendar
    }/year/:year`,
    DailyActivity: `/company/:companyId/vehicleModule/vehicle/:vehicleId/${
      ScreenTypes.VehicleModule.DailyActivity
    }/date/:date`,
    DailyActivityWithNoVehicle: `/company/:companyId/vehicleModule/${
      ScreenTypes.VehicleModule.DailyActivity
    }/date/:date`,
    WeeklyActivity: `/company/:companyId/vehicleModule/vehicle/:vehicleId/${
      ScreenTypes.VehicleModule.WeeklyActivity
    }/date/:date`,
    WeeklyActivityWithNoVehicle: `/company/:companyId/vehicleModule/${
      ScreenTypes.VehicleModule.WeeklyActivity
    }/date/:date`,
    Groups: `/company/:companyId/vehicleModule/vehicle/:vehicleId/${
      ScreenTypes.VehicleModule.Groups
    }`,
  },
  DriverModule: {
    Basic: '/company/:companyId/driverModule/:type?',
    BasicWithDate: '/company/:companyId/driverModule/:type/date/:date',
    BasicWithYear: '/company/:companyId/driverModule/:type/year/:year',
    BasicWithMonth: '/company/:companyId/driverModule/:type/month/:month',
    BasicWithDateRange:
      '/company/:companyId/driverModule/:type/from/:from/to/:to',
    WithDriver: '/company/:companyId/driverModule/driver/:driverId/:type?',
    WithDate:
      '/company/:companyId/driverModule/driver/:driverId/:type/date/:date',
    WithYear:
      '/company/:companyId/driverModule/driver/:driverId/:type/year/:year',
    WithMonth:
      '/company/:companyId/driverModule/driver/:driverId/:type/month/:month',
    WithSpecificId:
      '/company/:companyId/driverModule/driver/:driverId/:type/:id',
    WithDateRange:
      '/company/:companyId/driverModule/driver/:driverId/:type/from/:from/to/:to',
    BasicData: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.BasicData
    }`,
    BasicDataWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.BasicData
    }`,
    DailyActivity: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.DailyActivity
    }/date/:date`,
    DailyActivityWithoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.DailyActivity
    }/date/:date`,
    WeeklyActivity: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.WeeklyActivity
    }/date/:date`,
    WeeklyActivityWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.WeeklyActivity
    }/date/:date`,
    MonthlyActivity: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.MonthlyActivity
    }/month/:month`,
    MonthlyActivityWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.MonthlyActivity
    }/month/:month`,
    CompareActivity: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.CompareActivity
    }/date/:date`,
    CompareActivityWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.CompareActivity
    }/date/:date`,
    Calendar: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.Calendar
    }/year/:year`,
    CalendarWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.Calendar
    }/year/:year`,
    Attestation: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.Attestation
    }/from/:from/to/:to`,
    AttestationWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.Attestation
    }/from/:from/to/:to`,
    Timesheet: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.Timesheet
    }/month/:month`,
    TimesheetWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.Timesheet
    }/month/:month`,
    AmountsPreviewWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.AmountsPreview
    }/month/:month`,
    AmountsPreview: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.AmountsPreview
    }/month/:month`,
    ForeignAmountsWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.ForeignAmounts
    }/month/:month`,
    ForeignAmounts: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.ForeignAmounts
    }/month/:month`,
    ScheduleWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.Schedule
    }/year/:year`,
    Schedule: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.Schedule
    }/year/:year`,
    ViolationWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.Violation
    }/from/:from/to/:to`,
    Violation: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.Violation
    }/from/:from/to/:to`,
    GroupedViolation: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.GroupedViolation
    }/from/:from/to/:to`,
    GroupedViolationWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.GroupedViolation
    }/from/:from/to/:to`,
    BusinessTrip: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.BusinessTrip
    }/from/:from/to/:to`,
    BusinessTripWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.BusinessTrip
    }/from/:from/to/:to`,
    BusinessTripGpsDownload: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.GpsDownload
    }/from/:from/to/:to`,
    GroupedBusinessTrip: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.GroupedBusinessTrip
    }/from/:from/to/:to`,
    GroupedBusinessTripWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.GroupedBusinessTrip
    }/from/:from/to/:to`,
    NewBusinessTrip: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.NewBusinessTrip
    }/from/:from/to/:to`,
    NewGroupedBusinessTrip: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.NewGroupedBusinessTrip
    }/from/:from/to/:to`,
    EditBusinessTrip: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.EditBusinessTrip
    }/:id`,
    NewContract: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.NewContract
    }/:id/isAnnex/:isAnnex/fromTemplate/:fromTemplate`,
    EditContract: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.EditContract
    }/:id/isAnnex/:isAnnex/fromTemplate/:fromTemplate`,
    NewDriver: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.NewDriver
    }`,
    EditDriver: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.EditDriver
    }`,
    Groups: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.Groups
    }`,
    DriverList: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.DriverList
    }`,
    UnderConstruction: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.UnderConstruction
    }`,
    GroupedContract: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.GroupedContract
    }`,
    GroupedContractWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.GroupedContract
    }`,
    Contract: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.Contract
    }`,
    ContractWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.Contract
    }`,
    GroupedTimesheet: `/company/:companyId/driverModule/driver/:driverId/${
      ScreenTypes.DriverModule.GroupedTimesheet
    }/month/:month`,
    GroupedTimesheetWithNoDriver: `/company/:companyId/driverModule/${
      ScreenTypes.DriverModule.GroupedTimesheet
    }/month/:month`,
  },
  AdministrationPanel: {
    NoCompany: '/administrationPanel',
    NoCompanyTab: '/administrationPanel/:tab',
    Company: '/company/:companyId/administrationPanel',
    CompanyTab: '/company/:companyId/administrationPanel/:tab',
    EditCompany: '/company/:companyId/administrationPanel/editCompany',
    EditUser: '/company/:companyId/administrationPanel/editUser/:userId',
    EditUserNoCompany: '/administrationPanel/editUser/:userId',
    PaymentCompany: '/administrationPanel/companyPayment',
    DemoCompany: '/administrationPanel/demo',
  },
  DriverList: '/company/:companyId/driverModule/driverList',
  GenericError: '/error',
  GenericErrorWithCompany: '/company/:companyId/error',
  NotFound: '/notfound',
  MyProfle: {
    NoCompany: '/myprofile',
    Company: '/company/:companyId/myprofile',
  },
  FeaturesLayout: '/features',
  Features: {
    DASHBOARD: '/features/dashboard',
    DRIVERS: '/features/drivers',
    DRIVERS_LIST: '/features/drivers/list',
    DRIVERS_DETAILS: '/features/drivers/details',
    DRIVERS_GROUPS: '/features/drivers/groups',
    VEHICLES: '/features/vehicles',
    PRINTS: '/features/prints',
    IMPORT: '/features/import',
    EXPORT: '/features/export',
    CALENDAR: '/features/calendar',
    SETTINGS: '/features/settings',
  },

  Creator: '/creator',


  Legal: {
    Terms: '/terms',
    Privacy: '/privacy',
    Dpa: '/dpa',
    Contact: '/kontakt',
  },
}
